/**
 * CORE-1457 — показывает сообщения из `flashNotice` поверх любого экрана.
 *
 * Живёт в корне приложения, поэтому тост, отправленный уходящим экраном,
 * виден уже на том, куда человек пришёл. Только веб: на нативе о том же
 * говорит системный Alert, и менять его поведение тикет не просит.
 */
import React, { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { BrandToast } from './BrandToast';
import { hideFlashNotice, nextFlashNotice, subscribeFlashNotice, type FlashNotice } from '../utils/flashNotice';

/** Дольше обычного подтверждения: это новость, её надо успеть прочитать. */
const NOTICE_DURATION_MS = 5000;

export function FlashNoticeHost() {
  const [notice, setNotice] = useState<FlashNotice | null>(null);

  useEffect(() => {
    if (Platform.OS !== 'web') return undefined;
    return subscribeFlashNotice((message) => setNotice((prev) => nextFlashNotice(prev, message)));
  }, []);

  const seq = notice?.seq ?? 0;
  return (
    <BrandToast
      // CORE-1479 (возврат QA 23.10) — новый показ — новый тост: выезжает заново
      // и заново отсчитывает пять секунд, даже если текст тот же. Прежний показ,
      // догорая, гасит только себя (`hideFlashNotice`).
      key={seq}
      visible={!!notice}
      message={notice?.message ?? ''}
      onHide={() => setNotice((prev) => hideFlashNotice(prev, seq))}
      durationMs={NOTICE_DURATION_MS}
      iconName="information-circle-outline"
      iconColor="#E98245"
    />
  );
}
